import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Router } from '@angular/router';
import { RouteService } from '../../route.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private _authService: AuthService,
    private _routeService: RouteService,
    private _router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const authToken = this._authService.getToken();
    let path = this._router.routerState.snapshot.url;
    ////console.log(path);
    ////console.log(this._routeService.QueryParams.Data);
    ////console.log(path.indexOf("auth"));
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    ////console.log(req.body);
    //let CompanyID = (this._routeService.QueryParams.Data) ? this._routeService.QueryParams.Data.oid : req.body;
    let AppMenuID = (this._routeService.QueryParams.Data) ? this._routeService.QueryParams.Data.aid : req.body;

    ////console.log(bdy);
    //.console.log(authToken);
    //console.log(path);
    //console.log(path.indexOf("auth"));

    if (authToken != "" && path.indexOf("auth") < 0) {
      req = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + authToken),
        body: { ...req.body, AppMenuID }
        /* body: {...req.body, CompanyID} */
      });
      // console.log(req);
      //return next.handle(authReq);
    }
    return next.handle(req);

    // send cloned request with header to the next handler.
  }
}